@if (!isNotAuthPage()) {

<div class="xl:block hidden fixed py-2 top-0 start-0 end-0 z-20 ps-3"
  [class]="isLandingPage() ? 'bg-primary !text-white' : 'bg-primary-50 text-black'">
  <div class="container">
    <p-menubar [model]="isLoggedIn() ? items : items">
      <ng-template #start>
        @if (!isLandingPage()) {
        <img [routerLink]="['/']" class="cursor-pointer logo me-10" width="100px" src="Images/logo.png" alt="" />
        }
        @if (isLandingPage()) {
        <img [routerLink]="['/']" class="cursor-pointer logo me-10" width="100px" src="Images/logo-white.png" alt="" />
        }
      </ng-template>

      <ng-template #item let-item let-root="root">
        @if (item?.items) {
        <a class="flex w-full font-semibold items-center p-menubar-item-link"
          [class]="isLandingPage() ? 'bg-primary !text-white' : 'bg-primary-50 text-black'">
          <ng-icon [style]="{ color: isLandingPage() ? '#ffffff' : '#000000' }" class="me-2"
            [name]="'bootstrapChevronDown'" />
          <span class="capitalize" [class]="isLandingPage() ? 'bg-primary !!text-white' : 'bg-primary-50 text-black'">{{
            item?.label }}</span>
        </a>
        } @else {
        <a [routerLink]="[item?.routerLink]"
          class="flex w-full capitalize font-semibold items-center p-menubar-item-link duration-50" [class]="
                isLandingPage()
                  ? 'bg-primary !text-white hover:bg-primary-400'
                  : 'bg-primary-50 text-black hover:bg-white'
              ">
          <span class="capitalize">{{ item?.label }}</span></a>
        }
      </ng-template>

      <ng-template #end>
        <div class="flex justify-between items-center">
          <div [class]="isLandingPage() ? 'bg-primary !text-white' : 'bg-primary-50 text-black'"
            class="lg:flex hidden justify-between items-center"></div>
          @if (!isLoggedIn()) {
          <div class="flex items-center justify-between">
            <a [routerLink]="['/student/login']" class="me-5 cursor-pointer"
              [class]="isLandingPage() ? ' !text-white' : ' text-black'">Login</a>
            <app-main-btn [routerLink]="['/student/signup']" [btnTxColor]="isLandingPage() ? 'white' : 'black'"
              [btnColor]="'transparent'" [borderColor]="isLandingPage() ? 'white' : 'black'"
              [btnName]="'Join now for free'" />
          </div>
          }
          @if (isLoggedIn()) {
          <div class="flex items-center justify-between">
            <!-- <div [class]="isLandingPage() ? 'bg-white text-primary' : 'bg-primary !text-white'"
                class="w-[2rem] cursor-pointer bg-primary me-5 flex justify-center items-center h-[2rem] rounded-full">
                <ng-icon class="" name="bootstrapBellFill" />
              </div> -->

            <p-menu #menu [popup]="true" [model]="userItems" class="mx-auto">
              <ng-template #item let-item let-root="root">
                @if (item.router) {
                <a [routerLink]="[item?.router]"
                  class="flex w-full font-semibold group hover:!text-white items-center duration-50 bg-white p-menubar-item-link"
                  [class]="isLandingPage() ? 'text-primary hover:bg-primary' : 'text-black hover:bg-primary-50'">
                  <span [class]="
                            isLandingPage()
                              ? 'text-primary group-hover:bg-primary group-hover:!text-white'
                              : 'text-black group-hover:bg-primary-50 group-hover:!text-white'
                          ">{{ item?.label }}</span>
                </a>
                } @else {
                <a (click)="logout()"
                  class="flex w-full font-semibold group hover:!text-white items-center duration-50 bg-white p-menubar-item-link"
                  [class]="isLandingPage() ? 'text-primary hover:bg-primary' : 'text-black hover:bg-primary-50'">
                  <span [class]="
                            isLandingPage()
                              ? 'text-primary group-hover:bg-primary group-hover:!text-white'
                              : 'text-prmary group-hover:bg-primary-50 group-hover:text-black'
                          ">{{ item?.label }}</span>
                </a>
                }
              </ng-template>
            </p-menu>

            <p-button (click)="menu.toggle($event)">
              <p-avatar [image]="profileData()?.profile_image ?? 'Images/user.jpg'" shape="circle" />
            </p-button>
          </div>
          }
        </div>
      </ng-template>
    </p-menubar>
  </div>
</div>

<!-- ======================================================================================================================== -->
<div class="xl:hidden block fixed py-2 top-0 start-0 end-0 z-20"
  [class]="isLandingPage() ? 'bg-primary !text-white' : 'bg-primary-50 text-black'">
  <p-menubar (click)="onMenubarButtonClick($event)" [model]="isLoggedIn() ? items : itemsMobile">
    <ng-template #start>
      @if (!isLandingPage()) {
      <img [routerLink]="['/']" class="cursor-pointer logo me-auto" width="100px" src="Images/logo.png" alt="" />
      }
      @if (isLandingPage()) {
      <img [routerLink]="['/']" class="cursor-pointer logo me-auto" width="100px" src="Images/logo-white.png" alt="" />
      }
    </ng-template>

    <ng-template #end>
      <div class="flex justify-end w-full order-1 items-center">
        <!-- @if (!isLoggedIn()) {
            <div class="flex items-center justify-between">
              <a
                [routerLink]="['/student/login']"
                class="me-5"
                [class]="isLandingPage() ? ' !text-white' : ' text-black'"
                >Login</a
              >
              <app-main-btn
                [routerLink]="['/student/signup']"
                [btnTxColor]="isLandingPage() ? 'white' : 'black'"
                [btnColor]="'transparent'"
                [borderColor]="isLandingPage() ? 'white' : 'black'"
                [btnName]="'signup'" />
            </div>
          } -->

        @if (isLoggedIn()) {
        <div class="flex items-center justify-between">
          <!-- <div
                [class]="isLandingPage() ? 'bg-white text-primary' : 'bg-primary !text-white'"
                class="w-[2rem] bg-primary me-5 flex justify-center items-center h-[2rem] rounded-full" >
                <ng-icon class="" name="bootstrapBellFill" />
              </div> -->

          <p-menu #menu [popup]="true" [model]="userItems" class="mx-auto">
            <ng-template #item let-item let-root="root">
              @if (item.router) {
              <a [routerLink]="[item?.router]"
                class="flex w-full font-semibold group hover:bg-primary hover:!text-white items-center duration-50 bg-white p-menubar-item-link"
                [class]="isLandingPage() ? 'text-primary' : 'text-black'">
                <span [class]="
                          isLandingPage() ? 'text-primary group-hover:!text-white' : 'text-black group-hover:!text-white'
                        ">{{ item?.label }}</span>
              </a>
              } @else {
              <a (click)="logout()"
                class="flex w-full font-semibold group hover:bg-primary hover:!text-white items-center duration-50 bg-white p-menubar-item-link"
                [class]="isLandingPage() ? 'text-primary' : 'text-black'">
                <span [class]="
                          isLandingPage() ? 'text-primary group-hover:!text-white' : 'text-black group-hover:!text-white'
                        ">{{ item?.label }}</span>
              </a>
              }
            </ng-template>
          </p-menu>

          <p-button (click)="menu.toggle($event)">
            <p-avatar [image]="profileData()?.profile_image ?? 'Images/user.jpg'" shape="circle" />
          </p-button>
        </div>
        }
      </div>

      <ng-template #menuItem #item let-item let-root="root">
        @if (item?.items) {
        <a class="flex w-full font-semibold items-center group p-menubar-item-link" [class]="
                isLandingPage()
                  ? 'bg-white  text-primary group-hover:!text-white hover:bg-primary group-focus:!text-white focus:bg-primary'
                  : 'bg-primary-50 text-black  group-hover:text-black hover:bg-primary-50 group-focus:text-black focus:bg-primary-50'
              ">
          <span class="capitalize" [class]="
                  isLandingPage()
                    ? 'bg-white  text-primary group-hover:!text-white group-hover:bg-primary'
                    : 'bg-primary-50 text-black  group-hover:text-black group-hover:bg-primary-50'
                ">{{ item?.label }}</span>
          <ng-icon class="me-2" [name]="'bootstrapChevronDown'" />
        </a>
        } @else {
        <a [routerLink]="[item?.routerLink]"
          class="flex w-full capitalize font-semibold items-center group p-menubar-item-link bg-white hover:!text-white duration-50"
          [class]="
                isLandingPage()
                  ? 'text-primary hover:!text-white hover:bg-primary '
                  : 'text-black hover:text-black hover:bg-primary-50'
              ">
          <span class="capitalize"
            [class]="isLandingPage() ? 'text-primary group-hover:!text-white' : 'text-black group-hover:text-black'">
            {{ item?.label }}</span></a>
        }
      </ng-template>
    </ng-template>
  </p-menubar>
</div>
}

<!-- =============================================================================================================================== -->